import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerandering = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Verandering_svg__a)">
      <mask
        id="Verandering_svg__b"
        width={27}
        height={16}
        x={7}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M24 10V6l10 8-10 8v-4H7v-8z"
        />
      </mask>
      <g mask="url(#Verandering_svg__b)">
        <path
          fill="#F18700"
          d="M19.66 13.76 7.42 6.69l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="M-4.83-.39 7.42 6.69.35 18.93z"
        />
        <path
          fill="#F18700"
          d="M.35 18.93 7.42 6.69l12.24 7.07z"
        />
        <path
          fill="#F7A941"
          d="M14.49-5.56 7.42 6.69-4.83-.39z"
        />
        <path
          fill="#F18700"
          d="M.35 18.93 12.59 26 5.52 38.25zM24.84 33.08 12.59 26l7.07-12.24z"
        />
        <path
          fill="#F18700"
          d="M19.66 13.76 12.59 26 .35 18.93z"
        />
        <path
          fill="#F7A941"
          d="M38.98 8.58 26.73 1.51l7.08-12.25z"
        />
        <path
          fill="#F18700"
          d="m14.49-5.56 12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m19.66 13.76 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="m33.81-10.74 12.24 7.07-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="m19.66 13.76 12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="m44.16 27.9-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m38.98 8.58-7.07 12.25-12.25-7.07zM24.84 33.08l7.07-12.25 12.25 7.07z"
        />
      </g>
      <mask
        id="Verandering_svg__c"
        width={27}
        height={16}
        x={6}
        y={18}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M16 22v-4L6 26l10 8v-4h17v-8z"
        />
      </mask>
      <g mask="url(#Verandering_svg__c)">
        <path
          fill="#F7A941"
          d="m8.12 47.96-12.24-7.07 7.07-12.25z"
        />
        <path
          fill="#FED27A"
          d="M27.44 42.78 15.2 35.71l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m2.95 28.64 12.25 7.07-7.08 12.25z"
        />
        <path
          fill="#F7A941"
          d="M22.27 23.46 15.2 35.71 2.95 28.64z"
        />
        <path
          fill="#FED27A"
          d="m22.27 23.46 12.24 7.07-7.07 12.25zM27.44 42.78l7.07-12.25 12.25 7.07zM41.59 18.29l-7.08 12.24-12.24-7.07zM17.09 4.14l12.25 7.08-7.07 12.24zM41.59 18.29l-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#FED27A"
          d="m22.27 23.46 7.07-12.24 12.25 7.07zM-2.23 9.32l12.25 7.07-7.07 12.25zM22.27 23.46l-12.25-7.07 7.07-12.25z"
        />
        <path
          fill="#FED27A"
          d="m2.95 28.64 7.07-12.25 12.25 7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Verandering_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerandering);

export default ForwardRef;
